
/**
 * 트윗 유형
 */
export type TweetResponseBasicInfoAllOfTwoTweetType = typeof TweetResponseBasicInfoAllOfTwoTweetType[keyof typeof TweetResponseBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetResponseBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
